import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";

// Country - Get All
export const AllCountry = createAsyncThunk(
  "common/masters/all-country",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCountry}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      //return await Select2Data(res.data.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// State - Get All (for a specific country)
export const AllState = createAsyncThunk(
  "common/masters/all-state/:id",
  async ({ countryId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllState}/${countryId}?name=${name}`,
      );

  

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      // You can adjust Select2Data if necessary
      //return await Select2Data(res.data.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//City - Get All (for a specific State)
export const AllCity = createAsyncThunk(
  "common/masters/all-city/:id",
  async ({ stateId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCity}/${stateId}?name=${name}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      // You can adjust Select2Data if necessary
      //return await Select2Data(res.data.data, "city_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Pincode - Get All (for a specific City)
export const AllPincode = createAsyncThunk(
  "common/masters/all-pincode/:id",
  async ({ cityId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPincode}/${cityId}?name=${name}`,
      );

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data.data, "pincode_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllHomeBanner = createAsyncThunk(
  "common/homepage/all-homebanner",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllHomeBanner}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllBanner = createAsyncThunk(
  "common/about_us/all-banner",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllBanner}?name=${filter}`);

      const rawData = res?.data?.data || [];
      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      //return await Select2Data(res.data.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllWhoweare = createAsyncThunk(
  "common/about_us/all-whoweare",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllWhoweare}?name=${filter}`);

      const rawData = res?.data?.data || [];
      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      //return await Select2Data(res.data.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllOurGuidance = createAsyncThunk(
  "common/homepage/all-ourguidance",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllOurGuidance}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Moments - Get All
export const AllMoments = createAsyncThunk(
  "common/homepage/all-moments",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllMoments}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Blog - Get All
export const AllBlog = createAsyncThunk(
  "common/blogs/all-blog",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllBlog}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Career Banner - Get All
export const AllCareerBanner = createAsyncThunk(
  "common/careercounselling/all-careerbanner",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCareerBanner}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//What Career - Get All
export const AllWhatCareer = createAsyncThunk(
  "common/careercounselling/all-whatcareer",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllWhatCareer}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Career Process - Get All
export const AllCareerProcess = createAsyncThunk(
  "common/careercounselling/all-careerprocess",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCareerProcess}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Who should opt career - Get All
export const AllWhoShouldOpt = createAsyncThunk(
  "common/careercounselling/all-whoshouldopt",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllWhoShouldOpt}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Published book - Get All
export const AllPublishedBook = createAsyncThunk(
  "common/homepage/all-publishedbook",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllPublishedBook}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Alltypes = createAsyncThunk(
  "common/masters/all-types",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTypes}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Exam - Get All
export const AllExam = createAsyncThunk(
  "common/test/all-exam",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllExam}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "common",
  initialState: {
    all_country: [],
    all_state: [],
    all_city: [],
    all_pincode: [],
    all_homebanner: [],
    all_ourguidance: [],
    all_moments: [],
    all_blog: [],
    all_careerbanner: [],
    all_whatcareer: [],
    all_careerprocess: [],
    all_whoshouldopt: [],
    all_publishedbook: [],
    all_banner: [],
    all_whoweare: [],
    all_types: [],
    all_exam: [],
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(AllCountry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCountry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_country = action.payload || [];
      })
      .addCase(AllCountry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_state = action.payload || [];
      })
      .addCase(AllState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllCity actions
      .addCase(AllCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_city = action.payload || [];
      })
      .addCase(AllCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllPincode actions
      .addCase(AllPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_pincode = action.payload || [];
      })
      .addCase(AllPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Home Banner actions
      .addCase(AllHomeBanner.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllHomeBanner.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_homebanner = action.payload || [];
      })

      .addCase(AllHomeBanner.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Our Guidance actions
      .addCase(AllOurGuidance.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllOurGuidance.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_ourguidance = action.payload || [];
      })

      .addCase(AllOurGuidance.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Our Guidance actions
      .addCase(AllMoments.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllMoments.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_moments = action.payload || [];
      })

      .addCase(AllMoments.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Blog actions
      .addCase(AllBlog.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllBlog.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_blog = action.payload || [];
      })

      .addCase(AllBlog.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Career Banner actions
      .addCase(AllCareerBanner.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllCareerBanner.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_careerbanner = action.payload || [];
      })

      .addCase(AllCareerBanner.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All What career actions
      .addCase(AllWhatCareer.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllWhatCareer.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_whatcareer = action.payload || [];
      })

      .addCase(AllWhatCareer.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Career Process actions
      .addCase(AllCareerProcess.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllCareerProcess.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_careerprocess = action.payload || [];
      })

      .addCase(AllCareerProcess.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Who Should opt career actions
      .addCase(AllWhoShouldOpt.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllWhoShouldOpt.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_whoshouldopt = action.payload || [];
      })

      .addCase(AllWhoShouldOpt.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Published Book career actions
      .addCase(AllPublishedBook.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllPublishedBook.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_publishedbook = action.payload || [];
      })

      .addCase(AllPublishedBook.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllBanner.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBanner.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_banner = action.payload || [];
      })
      .addCase(AllBanner.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //AllWhoweare

      .addCase(AllWhoweare.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllWhoweare.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_whoweare = action.payload || [];
      })
      .addCase(AllWhoweare.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Alltypes.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Alltypes.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_types = action.payload || [];
      })
      .addCase(Alltypes.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for Exam
      .addCase(AllExam.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllExam.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_gallery = action.payload || [];
      })
      .addCase(AllExam.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
